/* eslint-disable consistent-return */
import { apileads } from '../enviroment/apileads';

const getDepartamentos = async () => {
  const response = await apileads.get('/v1/departamentos');
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

export {
  getDepartamentos,
};
